"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceGalleryComponent = exports.placeGalleryComponent = void 0;
var React = require("react");
var myokay_slider_1 = require("@okay/myokay-slider");
exports.placeGalleryComponent = function (props) {
    return (React.createElement("div", { style: { width: props.width, height: props.height } },
        React.createElement(myokay_slider_1.PreloadableGalleryComponent, { items: props.items, slideIndex: props.slideIndex, onItemClick: props.onItemClick, onSlideIndexChanged: props.onSlideIndexChanged })));
};
exports.PlaceGalleryComponent = exports.placeGalleryComponent;
